import React from "react";
import { ScrollToTopButton } from "../components/ScrollToTopButton/ScrollToTopButton";
import { HeaderTwo } from "../components/Headers/HeaderTwo";
import { FooterTwo } from "../components/Footers/FooterTwo";
import { Breadcrumb } from "../components/Breadcrumb/Breadcrumb";

export const Layout = ({ children, breadcrumb, title }) => {
  return (
    <>
      <ScrollToTopButton />
      <HeaderTwo />
      {breadcrumb && <Breadcrumb text={breadcrumb} title={title} />}
      <main className="fix">{children}</main>
      <FooterTwo />
    </>
  );
};
